import React from 'react'
import { Icon, makeStyles, useTheme } from '@material-ui/core'

export const Tag = ({
  title,
  color,
}: {
  title: string
  color?: string
}) => {
  const theme = useTheme()
  const { tag } = useStyles()
  const c = color || theme.palette.grey[100]

  return <span
    className={tag}
    style={{
      backgroundColor: c,
      color: theme.palette.getContrastText(c),
    }}>
    {title}
  </span>
}

export const IconLabel = ({ icon, label }: { icon?: string, label: string }) => {
  const { tagLabel, tagLabelIcon } = useStyles()
  return <span className={tagLabel}>
    {icon ? <Icon className={tagLabelIcon}>{icon}</Icon> : null}
    {label}
  </span>
}

const useStyles = makeStyles({
  tag: {
    '&:last-of-type': {
      margin: '2px 0',
    },
    padding: '4px 8px',
    borderRadius: 6,
    margin: 2,
    whiteSpace: 'nowrap',
    display: 'inline-block',
  },
  tagLabel: {
    display: 'flex',
    alignItems: 'center',
  },
  tagLabelIcon: {
    marginRight: 4,
  },
})

